<wc-grid
  gridKey="clientDataSets"
  [context]="gridContext"
  [contextMenuItems]="rowActions"
  (contextMenuAction)="onRowAction($event)">
</wc-grid>
